import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Savings from '../components/Savings';
import MortgageTypesSection from '../components/MortgageTypesSection';
import BaseSection from '../components/BaseSection';
import CTASection from '../components/CTASection';
import Testimonials from '../components/Testimonials';
import RecentTransactions from '../components/RecentTransactions';
import SocialProof from '../components/SocialProof';
import FAQ from '../components/FAQ';
import PartnerLogos from '../components/PartnerLogos';
import Footer from '../components/Footer';

const Home: React.FC = () => {
  return (
    <div className="App">
      <Navbar />
      <main style={{ marginTop: '83px' }}>
        <Hero />
        <Savings />
        <MortgageTypesSection />
        <BaseSection />
        <CTASection />
        <Testimonials />
        <RecentTransactions />
        <SocialProof />
        <FAQ />
        <PartnerLogos />
        <Footer />
      </main>
    </div>
  );
};

export default Home;

